import Header from "./header";
import Footer from "./footer";
import "../css/board.css";
import { apiUrl } from "../config/api";
import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import LocaleContext from "../context/localeContext";

// 게시판 기능
function Board() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const { category } = useParams();

  useEffect(() => {
    const mainHeader = document.querySelector("#main-header");
    if (mainHeader) {
      setHeaderHeight(mainHeader.clientHeight);
    }
  }, []);

  return (
    <>
      <Header></Header>
      <Main headerHeight={headerHeight} category={category}></Main>
      <Footer></Footer>
    </>
  );
}

function Main({ headerHeight, category }) {
  const isAuthorized = useContext(LocaleContext);
  const [isSearched, setIsSearched] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  const [contents, setContents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  // api
  useEffect(() => {
    fetch(apiUrl(`/api/get/${category}?page=${currentPage}`))
      .then((res) => res.text())
      .then((res) => {
        const response = JSON.parse(res);
        setContents(response.paginatedData);
        setTotalPage(response.totalPages);
      })
      .catch((err) => {
        alert("err: ", err);
      });
  }, [category, currentPage]);

  const pageNumbers = Array.from(
    { length: totalPage },
    (_, index) => index + 1
  );
  const path = {
    history: "연구 사업",
    issue: "이슈&솔루션",
    news: "연구원 소식",
    country: "지역&나라발전",
  };

  function handleClickWriteBtn(category) {
    window.location.href = `/write/${category}`;
  }

  function handleClickRow(num) {
    window.location.href = `/detail/${category}/${num}`;
  }

  // Start:: Search
  function handleChangeSearchValue(e) {
    setSearchValue(e.target.value);
  }
  function handleClickSearchBtn() {
    if (searchValue === "") {
      setIsSearched(false);
    } else {
      setIsSearched(true);
      const q = String(searchValue).trim().toLowerCase();
      const filteredData = contents.filter((item) => {
        // Guard against non-string titles/contents
        const title = item && item.title ? String(item.title) : "";
        const body = item && item.contents ? String(item.contents) : "";
        return (
          title.toLowerCase().includes(q) || body.toLowerCase().includes(q)
        );
      });
      setSearchResult(filteredData);
    }
  }

  function handleKeyPress(e) {
    if (e.key === "Enter") {
      handleClickSearchBtn(e);
    }
  }
  // End:: Search

  return (
    <>
      <div
        className="container history py-5"
        style={{ marginTop: `${headerHeight}px` }}
      >
        <div className="page-header d-flex flex-column align-items-center">
          <h3 className="mb-5">{path[category]}</h3>
          <div className="w-100 d-flex justify-content-between">
            <div className="action write">
              {isAuthorized && (
                <div
                  className="btn btn-outline-primary"
                  onClick={() => {
                    handleClickWriteBtn(category);
                  }}
                >
                  글쓰기
                </div>
              )}
            </div>
            <div className="search d-flex">
              <input
                className="form-control"
                placeholder="검색어를 입력하세요."
                type="text"
                name="search"
                id="search"
                onChange={handleChangeSearchValue}
                onKeyDown={handleKeyPress}
              />
              <input
                className="btn btn-primary ms-2 px-3"
                type="button"
                value="검색"
                onClick={handleClickSearchBtn}
              />
            </div>
          </div>
        </div>
        <div className="page-body my-3">
          <table className="table">
            <thead>
              <tr>
                <td className="num">NO.</td>
                <td className="author">작성자</td>
                <td className="title">제목</td>
                <td className="date">날짜</td>
              </tr>
            </thead>
            <tbody>
              {!isSearched
                ? contents?.map((el) => {
                    return (
                      <tr
                        key={el.id}
                        onClick={() => {
                          handleClickRow(el.id);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{el.id}</td>
                        <td>{el.author}</td>
                        <td>{el.title}</td>
                        <td>{el.date}</td>
                      </tr>
                    );
                  })
                : searchResult?.map((el) => {
                    const id = el.id ?? el.no; // support different shapes
                    return (
                      <tr
                        key={id}
                        onClick={() => {
                          handleClickRow(id);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{id}</td>
                        <td>{el.author}</td>
                        <td>{el.title}</td>
                        <td>{el.date}</td>
                      </tr>
                    );
                  })}
            </tbody>
          </table>
        </div>
        <div className="page-footer py-3">
          <nav className="d-flex justify-content-center">
            <ul className="pagination">
              <li className="page-item">
                <button
                  className="page-link"
                  aria-label="Previous"
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                >
                  <span aria-hidden="true">&laquo;</span>
                </button>
              </li>
              {pageNumbers?.map((number) => (
                <li className="page-item" key={number}>
                  <button
                    className={
                      number === currentPage ? "page-link active" : "page-link"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setCurrentPage(number);
                    }}
                  >
                    {number}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link"
                  aria-label="Next"
                  onClick={() =>
                    setCurrentPage(Math.min(totalPage, currentPage + 1))
                  }
                >
                  <span aria-hidden="true">&raquo;</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Board;
